import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerSwUpdateReload } from './lib/swUpdate';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

registerSwUpdateReload();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
